module.exports = __webpack_public_path__ + "img/20.527ed10f.jpg";